"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIssues = exports.IGroupedBlueprint = void 0;
class IGroupedBlueprint {
    name;
    blueprints;
}
exports.IGroupedBlueprint = IGroupedBlueprint;
class StepIssues {
    controls;
    integration;
}
exports.StepIssues = StepIssues;
//# sourceMappingURL=notification-template.interface.js.map